<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="340"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="enableSubmit"
        color="primary"
        dark
        v-on="on"
      >
        {{ $t('message.draft_submit_button') }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">
        {{ $t('message.confirm_draft_submit_title') }}
      </v-card-title>
      <v-card-text>{{ $t('message.confirm_draft_submit_text') }}</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          flat
          @click.stop="show = false"
        >
          {{ $t('message.draft_submit_dialog_no_button') }}
        </v-btn>
        <v-btn
          color="primary"
          @click="$emit('confirm')"
        >
          {{ $t('message.draft_submit_dialog_yes_button') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    enableSubmit: {
      type: Boolean,
      default: false,
    },
    value: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
}
</script>
